export default __webpack_public_path__ + "static/media/unsubscribe-email-header-preview.5789c962.png";